import constate from 'constate';

export const [OriginTenantSlugProvider, useOriginTenantSlug] = constate(
	(props: { originTenantSlug: string }) => props.originTenantSlug,
);
